"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var DeterminateSpinner = function DeterminateSpinner(_ref) {
  var classes = _ref.classes,
      props = (0, _objectWithoutProperties2.default)(_ref, ["classes"]);
  return React.createElement(_CircularProgress.default, (0, _extends2.default)({
    className: classes.flatSpinner,
    variant: "indeterminate"
  }, props));
};

var IndeterminateSpinner = function IndeterminateSpinner(props) {
  return React.createElement(_CircularProgress.default, (0, _extends2.default)({
    variant: "indeterminate"
  }, props));
};

var StaticSpinner = function StaticSpinner(props) {
  return React.createElement(_CircularProgress.default, (0, _extends2.default)({
    variant: "static"
  }, props));
};

var SpinnerTypes = {
  determinate: DeterminateSpinner,
  indeterminate: IndeterminateSpinner,
  static: StaticSpinner
};

var Spinner =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Spinner, _React$PureComponent);

  function Spinner() {
    (0, _classCallCheck2.default)(this, Spinner);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Spinner).apply(this, arguments));
  }

  (0, _createClass2.default)(Spinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          size = _this$props.size,
          thickness = _this$props.thickness,
          type = _this$props.type;
      var SpinnerComponent = SpinnerTypes[type];
      return React.createElement(SpinnerComponent, {
        classes: classes,
        size: size,
        thickness: thickness
      });
    }
  }]);
  return Spinner;
}(React.PureComponent);

Spinner.defaultProps = {
  classes: {},
  size: 40,
  type: 'indeterminate',
  thickness: 3.6
};
Spinner.propType = {
  /**
   * classes: Style object
   */
  classes: PropTypes.object,

  /**
   * size: Size of spinner
   */
  size: PropTypes.number,

  /**
   * thickness: how thick is the spinner
   */
  thickness: PropTypes.number,

  /**
   * type:  Different types of spins you can choose
   */
  type: PropTypes.oneOf(['determinate', 'indeterminate', 'static'])
};
var _default = Spinner;
exports.default = _default;